/**
 * @generated SignedSource<<baae504b4e315b3913638f4afa56b024>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HydrantManufacturerInputHydrantManufacturersQuery$variables = {};
export type HydrantManufacturerInputHydrantManufacturersQueryVariables = HydrantManufacturerInputHydrantManufacturersQuery$variables;
export type HydrantManufacturerInputHydrantManufacturersQuery$data = {
  readonly hydrantManufacturers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type HydrantManufacturerInputHydrantManufacturersQueryResponse = HydrantManufacturerInputHydrantManufacturersQuery$data;
export type HydrantManufacturerInputHydrantManufacturersQuery = {
  variables: HydrantManufacturerInputHydrantManufacturersQueryVariables;
  response: HydrantManufacturerInputHydrantManufacturersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HydrantManufacturerConnection",
    "kind": "LinkedField",
    "name": "hydrantManufacturers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HydrantManufacturerEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HydrantManufacturer",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HydrantManufacturerInputHydrantManufacturersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HydrantManufacturerInputHydrantManufacturersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b36be044be5458f237bf56f3de480eae",
    "id": null,
    "metadata": {},
    "name": "HydrantManufacturerInputHydrantManufacturersQuery",
    "operationKind": "query",
    "text": "query HydrantManufacturerInputHydrantManufacturersQuery {\n  hydrantManufacturers {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa8b62400cd731fc1b4e895714b4307b";

export default node;
